import React from 'react';
import '../Icon/ImgIcon.esm.js';
import { LoadingIcon } from '../Icon/SemanticIcons.esm.js';

function LoadingPanel({ dataMetrics, dataTestId }) {
    return (React.createElement("div", { className: "tw-flex tw-items-center tw-justify-center tw-h-full", "data-testid": dataTestId || 'Loading Panel', "data-metrics": dataMetrics },
        React.createElement(LoadingIcon, { size: "5xl" })));
}

export { LoadingPanel };
//# sourceMappingURL=LoadingPanel.esm.js.map
